import { API_ROUTES, clientSummarySchema } from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from './queries.js';

/** One client's month in one row. Read per client by the firm's desk. */
export const clientSummaryQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['firm', organizationId, 'summary'] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.reports.clientSummary(organizationId),
        schema: clientSummarySchema,
        signal,
      }),
    staleTime: 60_000,
  });
